// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"d0ade1b4061a4faa72b5","303":"bfd8fe43890b5f716163","495":"4321fd2ac8b440ff6ef6"}[chunkId] + ".js";
};